module.exports = __webpack_public_path__ + "img/GB.c39480d5.svg";